import classNames from "classnames";
import Badge from "@/components/base/badge";
import Text from "@/components/base/text";

const OptionButton = ({
  title,
  description,
  shippingCost,
  badgeText,
  badgeColor,
  onClick,
  selected = false,
  disabled = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "form-input w-full px-3 pt-2 pb-6 rounded-lg",
        selected
          ? "bg-light-purple"
          : "bg-transparent hover:bg-light-purple/10 group hover:border hover:border-light-purple",
        disabled && "border-none outline-none shadow-none"
      )}
      disabled={disabled}
    >
      <div className="flex justify-end">
        <Badge color={badgeColor}>{badgeText}</Badge>
      </div>
      <div className="px-2 pt-2">
        <Text
          className={classNames(selected && "text-white")}
          color="primary"
          weight="bold"
          align="center"
          size="sm"
        >
          {title}
        </Text>
        <Text
          className={classNames(
            "mt-1 whitespace-pre-wra",
            selected && "text-white"
          )}
          align="center"
          size="sm"
        >
          {description}{" "}
          <Text
            as="span"
            className={classNames("italic", selected && "text-white")}
            color="primary"
            weight="extrabold"
          >
            SGD {shippingCost || ""}
          </Text>
        </Text>
      </div>
    </button>
  );
};

export default OptionButton;
